import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { saveEnquiry } from '../services/enquiryService';

function Demo() {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: '',
  });
  const [submitting, setSubmitting] = useState(false);

  const product = location.state?.product;
  const cartItems = location.state?.cart ?? [];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const result = await saveEnquiry({
        type: 'demo',
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        serviceType: formData.serviceType,
        product: product || null,
        cartItems: cartItems.length ? cartItems : null,
      });
      if (!result.ok) {
        alert(result.error || 'Could not save your enquiry. Please try again.');
        return;
      }
      alert(
        'Thank you for your enquiry! We will contact you shortly with more details about our AMC and maintenance services.'
      );
      navigate('/');
    } catch (err) {
      alert(err?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="section" id="demo">
      <div className="demo-container">
        <div className="demo-header">
          <h1>AMC & Repair Enquiry</h1>
          <p>
            Fill out the form below and our team will contact you shortly with details about our AMC (Annual Maintenance Contract), repair, and maintenance services for all kinds of lifts.
          </p>
        </div>

        <form className="demo-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your.email@example.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number *</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="+91 1234567890"
            />
          </div>

          <div className="form-group">
            <label htmlFor="serviceType">Service Type *</label>
            <select
              id="serviceType"
              name="serviceType"
              value={formData.serviceType}
              onChange={handleChange}
              required
            >
              <option value="">Select service type</option>
              <option value="amc">AMC (Annual Maintenance Contract)</option>
              <option value="repair">Repair Service</option>
              <option value="emergency">Emergency Repair</option>
              <option value="modernization">Lift Modernization</option>
            </select>
          </div>

          <button type="submit" className="primary submit-btn" disabled={submitting}>
            {submitting ? 'Submitting…' : 'Get Quote'}
          </button>
        </form>
      </div>
    </section>
  );
}

export default Demo;
